import styled from 'styled-components';

export const BannerContainer = styled.div`
  .hefesto-banner {
    top: 25%;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptopL}) {
      top: 18%;
    }
  }
`;
